// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nameBox[data-v-226bdae8] {\n  font-weight: bold;\n  margin-bottom: 20px;\n  padding-left: 20px;\n  font-size: 20px;\n}\n.btnBox[data-v-226bdae8] {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 50px;\n  align-items: center;\n}\n.btnBox .personnel-detail[data-v-226bdae8] {\n  position: absolute;\n  right: -15px;\n}", ""]);
// Exports
module.exports = exports;
